<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  let _self;
  export default {
    name: 'App',
    created(){
      _self = this;
      let login_voucher = JSON.parse(localStorage.getItem('login_voucher'));
      if(login_voucher){
        _self.$VueX.state.state.user_unique_key = login_voucher.user_unique_key; //用户秘钥
        _self.$VueX.state.state.access_token = login_voucher.access_token; //访问令牌
        _self.$VueX.state.state.isLogin = true; //登录状态
      }
    }
  }
</script>
<style lang="scss">
  /*重写input的placeholder样式*/
  .el-input__inner {
    &::placeholder {
      color: #576786;
      font-size: 14px;
    }
    &::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      color: #576786;
      font-size: 14px;
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #576786;
      /*font-size: 14px;*/
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      color: #576786;
      /*font-size: 14px;*/
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      color: #576786;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue